import { useTranslation } from 'react-i18next';

import { Close, VButton, VFlex, VInput, VStack, VTextButton } from '@/package';

type TrackIDChangeRequestNotificationProps = {
  nextTrackID: string;
  onApply: () => void;
  onReject: () => void;
};

export const TrackIDChangeRequestNotification = ({
  nextTrackID,
  onApply,
  onReject,
}: TrackIDChangeRequestNotificationProps) => {
  const { t } = useTranslation();

  return (
    <VStack
      className="w-full rounded-sm border border-skyBlue-200 bg-skyBlue-100 p-scale/4"
      gap={0.25}
    >
      <VFlex gap={0.25} items="center" justify="between">
        <div className="text-body-md font-semibold text-black">
          {t('labeling.boxInspectorTrackIDChangeRequest.heptavalent')}
        </div>
        <VTextButton
          className="text-body-sm text-gray-500"
          size="xs"
          onPointerUp={onReject}
        >
          <VFlex gap={0.25} items="center">
            <Close className="size-3" />
            <span>
              {t(
                'labeling.boxInspectorTrackIDChangeRequestDoNotApplyButtonText.rethrust',
              )}
            </span>
          </VFlex>
        </VTextButton>
      </VFlex>

      <VFlex gap={0.25}>
        <VInput
          fluid
          label="Track ID"
          inputClassName="text-right"
          orientation="horizontal"
          readOnly
          size="sm"
          type="text"
          value={nextTrackID}
        />
        <VButton size="sm" onClick={onApply}>
          {t('labeling.boxInspectorTrackIDChangeRequestApply.retroposition')}
        </VButton>
      </VFlex>
    </VStack>
  );
};

TrackIDChangeRequestNotification.displayName =
  'TrackIDChangeRequestNotification';
